import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';

//import images
import logoDark from '../../assets/images/watopa/watopa-dark.png';
import logoLight from '../../assets/images/watopa/watopa-light.png';

//Import Icons
import FeatherIcon from 'feather-icons-react';

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      open: false,
      position: 'right',
    };
    this.toggleRightDrawer = this.toggleRightDrawer.bind(this);
    this.onDrawerClose = this.onDrawerClose.bind(this);
  }
  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  toggleRightDrawer = () => {
    this.setState({ position: 'right' });
    this.setState({ open: !this.state.open });
  };
  onDrawerClose = () => {
    this.setState({ open: false });
  };

  initMenu() {
    this.activateMenu();
  }

  activateMenu() {
    var menuItems = document.getElementsByClassName('sub-menu-item');
    if (menuItems) {
      var matchingMenuItem = null;
      for (var idx = 0; idx < menuItems.length; idx++) {
        if (menuItems[idx].href === window.location.href) {
          matchingMenuItem = menuItems[idx];
        }
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add('active');
        const immediateParent = matchingMenuItem.closest('li');
        if (immediateParent) {
          immediateParent.classList.add('active');
        }
        const parent = matchingMenuItem.closest('.parent-menu-item');
        if (parent) {
          parent.classList.add('active');
          var parentMenuitem = parent.querySelector('.menu-item');
          if (parentMenuitem) {
            parentMenuitem.classList.add('active');
          }
          const parentOfParent = parent.closest('.parent-menu-item-sub');
          if (parentOfParent) {
            parentOfParent.classList.add('active');
          }
        } else {
          const parentOfParent = matchingMenuItem.closest(
            '.parent-menu-item-sub',
          );
          if (parentOfParent) {
            parentOfParent.classList.add('active');
          }
        }
      }
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.initMenu();
    if (document.body) document.body.classList = '';
    document.querySelectorAll('#buyButton').forEach((navLink) => {
      if (navLink) {
        navLink.classList.add('btn-light');
        navLink.classList.remove('btn-soft-primary');
      }
    });
    // window.addEventListener('scroll', this.scrollNavigation, true);
  }

  // Make sure to remove the DOM listener when the component is unmounted.
  UNSAFE_componentWillMount() {
    // window.removeEventListener('scroll', this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var doc = document.documentElement;
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (top > 80) {
      // document.getElementById('topnav').classList.add('nav-sticky');
    } else {
      // document.getElementById('topnav').classList.remove('nav-sticky');
    }
  };

  /**
   * Toogle menu in mobile screen
   */
  isToogleMenu = () => {
    const isToggle = document.getElementById('isToggle');
    if (isToggle) {
      isToggle.classList.toggle('open');
      var isOpen = document.getElementById('navigation');
      console.log('navgiationId', isOpen);
      if (isOpen.style.display === 'block') {
        isOpen.style.display = 'none';
      } else {
        isOpen.style.display = 'block';
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        <header id="topnav" className="defaultscroll sticky">
          <Container>
            <div>
              <Link className="logo" to="/">
                <span className="logo-light-mode">
                  <img src={logoDark} className="l-dark" height="40" alt="" />
                  <img src={logoLight} className="l-light" height="40" alt="" />
                </span>
                <img
                  src={logoLight}
                  height="40"
                  className="logo-dark-mode"
                  alt=""
                />
              </Link>
            </div>

            <div className="menu-extras">
              <div className="menu-item">
                <Link
                  to="#"
                  className="navbar-toggle"
                  id="isToggle"
                  onClick={this.isToogleMenu}
                >
                  <div className="lines">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </Link>
              </div>
            </div>

            <div id="navigation">
              <ul className="navigation-menu nav-light">
                <li>
                  <a href="#home" className="sub-menu-item">
                    Inicio
                  </a>
                </li>
                <li>
                  <a href="#services" className="sub-menu-item">
                    Servicios
                  </a>
                </li>
                <li>
                  <a href="#features" className="sub-menu-item">
                    Características
                  </a>
                </li>
                <li>
                  <a href="#team" className="sub-menu-item">
                    Equipo
                  </a>
                </li>
                <li>
                  <a href="#contact" className="sub-menu-item">
                    Contacto
                  </a>
                </li>
              </ul>
            </div>
          </Container>
        </header>
      </React.Fragment>
    );
  }
}

export default NavBar;
